import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getStateList = (countryId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.TABULAR_REPORT.GET_STATE_LIST(countryId)
  );
};

export default getStateList;
